"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Announcer = _interopRequireDefault(require("./Announcer"));
var _AnnouncerContext = _interopRequireDefault(require("./AnnouncerContext"));
var _interfaces = require("./interfaces");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LiveAnnouncer = _ref => {
  let {
    children
  } = _ref;
  const [politeLogMessage, setPoliteLogMessage] = (0, _react.useState)(undefined);
  const [politeStatusMessage, setPoliteStatusMessage] = (0, _react.useState)(undefined);
  const [assertiveLogMessage, setAssertiveLogMessage] = (0, _react.useState)(undefined);
  const [assertiveStatusMessage, setAssertiveStatusMessage] = (0, _react.useState)(undefined);
  const [isAriaAtomic, setIsAriaAtomic] = (0, _react.useState)(true);
  const announcePolite = _ref2 => {
    let {
      region,
      role,
      isAriaAtomic
    } = _ref2;
    if (!isAriaAtomic) {
      setIsAriaAtomic(false);
    }
    switch (role) {
      case _interfaces.LiveRegionRole.Status:
        setPoliteStatusMessage(region);
        return;
      case _interfaces.LiveRegionRole.Log:
        setPoliteLogMessage(region);
        return;
      default:
        return;
    }
  };
  const announceAssertive = _ref3 => {
    let {
      region,
      role,
      isAriaAtomic
    } = _ref3;
    if (!isAriaAtomic) {
      setIsAriaAtomic(false);
    }
    switch (role) {
      case _interfaces.LiveRegionRole.Status:
        setAssertiveStatusMessage(region);
        return;
      case _interfaces.LiveRegionRole.Log:
        setAssertiveLogMessage(region);
        return;
      default:
        return;
    }
  };
  const updateFunctions = (0, _react.useMemo)(() => ({
    announceAssertive,
    announcePolite
  }), []);
  return (0, _react2.jsx)(_AnnouncerContext.default.Provider, {
    value: updateFunctions
  }, children, (0, _react2.jsx)(_Announcer.default, {
    "aria-atomic": isAriaAtomic,
    politeLogRegion: politeLogMessage,
    politeStatusRegion: politeStatusMessage,
    assertiveLogRegion: assertiveLogMessage,
    assertiveStatusRegion: assertiveStatusMessage
  }));
};
var _default = exports.default = LiveAnnouncer;